import type { TemporaryContactRecord } from '@shared/types';
import type { TemporaryMembership } from '../store/authStore';

export function listTemporaryContacts(
  temporaryMemberships: Record<string, TemporaryMembership>
): TemporaryContactRecord[] {
  const seen = new Set<string>();
  const result: TemporaryContactRecord[] = [];

  for (const membership of Object.values(temporaryMemberships)) {
    for (const contact of membership.cachedContacts || []) {
      const key = `${membership.identityId}::${contact.contactId}`;
      if (seen.has(key)) continue;
      seen.add(key);
      result.push(contact);
    }
  }

  return result;
}

export function findTemporaryMembershipByIdentityId(
  temporaryMemberships: Record<string, TemporaryMembership>,
  identityId: string
): TemporaryMembership | null {
  const cleanIdentityId = (identityId || '').trim();
  if (!cleanIdentityId) return null;

  for (const membership of Object.values(temporaryMemberships)) {
    if ((membership.identityId || '').trim() === cleanIdentityId) {
      return membership;
    }
  }

  return null;
}

export function findTemporaryContactByIdentityId(
  temporaryMemberships: Record<string, TemporaryMembership>,
  identityId: string
): TemporaryContactRecord | null {
  const cleanIdentityId = (identityId || '').trim();
  if (!cleanIdentityId) return null;

  for (const membership of Object.values(temporaryMemberships)) {
    const contact = (membership.cachedContacts || []).find((candidate) =>
      (candidate.identities || []).some((identity) => (identity.identityId || '').trim() === cleanIdentityId)
    );
    if (contact) return contact;
  }

  return null;
}
